<template>
    <div class="flex space-x-2">
        <span class="w-1/4 font-medium text-taupe-800">{{ label }}</span>
        <span class="w-3/4 font-normal text-taupe-800 truncate">
            <slot>
                {{ value }}
            </slot>
        </span>
    </div>
</template>

<script setup>
defineOptions({
    name: 'ZenGridMobileDetailItem',
})

defineProps({
    label: {
        type: String,
        required: true,
    },
    value: {
        type: String,
        required: false,
    },
})
</script>
